import gql from 'graphql-tag'
export default gql`
  mutation updateProviderAuth ($value: ProviderAuth!) {
    updateProviderAuth(value: $value) @client {
      uid
      providerID
      userID
      displayName
      emailVerified
      token
      photoUrl
      email
      isAnonymous
      ready
    }
  }
`
